const setFilterValues = (filterValues: any) => ({
  type: 'SET_FILTER_VALUES',
  filterValues,
})

export default setFilterValues
